import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

// Sélecteur défini UNE fois au niveau module. Auparavant `createSelector` était recréé à chaque
// appel du hook : sans mémoïsation partagée et surtout alloué à chaque rendu de CHAQUE cellule de
// grille qui lit le workspace (une centaine par rendu). Un sélecteur module-level supprime cette
// allocation tout en renvoyant la même référence `currentWorkspace` qu'avant.
const selectCurrentWorkspace = createSelector(
    [(state: RootState) => state.appSettings.currentWorkspace],
    (currentWorkspace) => currentWorkspace
);

export const useCurrentWorkspace = () => useSelector(selectCurrentWorkspace);